import React from 'react';
import { useForm } from "react-hook-form";

const Feedback = () => {
    const { register, handleSubmit } = useForm();
    const onSubmit = data => console.log(data);

    return (
        <div className='md:py-10 py-6 '>
            <div>
                <h1 className='text-center text-4xl mb-4 font-bold md:text-4xl text-sky-900 '>Write Something About Us</h1>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className='md:grid grid-cols-1 md:w-1/2 mx-auto w-full px-4'>

                {/* <div className='text-xl font-semibold mr-2'>First Name:</div> */}
                <div className='flex mt-6 mb-3'>
                    <input {...register("firstName", { required: true })} placeholder='First Name'
                        name='firstName'
                        id='firstName'
                        className='input input-bordered focus:outline-none w-full mr-3'
                    />

                    <input {...register("lastName", { required: true })} placeholder='Last Name'
                        className='input input-bordered focus:outline-none w-full'
                        name='lastName'
                        id='lastName'
                    />
                </div>

                <div className='flex mb-3'>
                    <input {...register("standard", { required: true })} placeholder='Your Standard'
                        className='input input-bordered focus:outline-none w-full flex-1 '
                    />
                    <select className="select w-full flex-1 focus:outline-none ml-3">
                        <option>Course</option>
                        <option >Engineering colleges</option>
                        <option>Medical colleges</option>
                        <option>Pharma college</option>
                        <option>Law Colleges</option>
                        <option>MBA</option>
                    </select>
                </div>
                <input {...register("email", { required: true })} type="email" name="email" id="email" placeholder='Your email'
                    className='input input-bordered focus:outline-none w-full'
                />
                <textarea name="message" id="message" cols="" rows=""
                    className='textarea w-full mt-3 focus:outline-none'
                ></textarea>
                <input type="submit"
                    className='bg-green-400 hover:bg-green-500 rounded px-4 py-2 text-white w-24 mx-auto mt-3 cursor-pointer'
                />
            </form>
        </div>
    );
};

export default Feedback;